import isObject from 'lodash/isObject';

function isCanceledPromise(error) {
    return isObject(error) && error.canceled === true;
}

export default isCanceledPromise;
